export default class ProductDescription {
    constructor(el) {
        if (!el) return;

        this.el = el;
        this.wordLimit = parseInt(el.dataset.wordLimit, 10) || 15;
        this.readMoreText = el.dataset.readMoreText || 'Read more';
        this.readLessText = el.dataset.readLessText || 'Read less';
        this.fullHTML = el.innerHTML;

        const words = el.innerText.trim().split(/\s+/).filter(Boolean);

        if (words.length <= this.wordLimit) {
            el.classList.remove('overflow-hidden', 'max-h-14');
            return;
        }

        this.truncatedHTML = `${words.slice(0, this.wordLimit).join(' ')}… <button type="button" class="font-normal text-[#7755AD] underline underline-offset-1 js-desc-read-more">${this.readMoreText}</button>`;

        el.classList.remove('overflow-hidden', 'max-h-14');
        this.collapse();
    }

    expand() {
        this.el.innerHTML = `${this.fullHTML} <button type="button" class="font-normal text-[#7755AD] underline underline-offset-1 js-desc-read-less">${this.readLessText}</button>`;
        this.el.querySelector('.js-desc-read-less').addEventListener('click', () => this.collapse());
    }

    collapse() {
        this.el.innerHTML = this.truncatedHTML;
        this.el.querySelector('.js-desc-read-more').addEventListener('click', () => this.expand());
    }
}
